import React, {FC, useState} from 'react';

import loginImage from 'assets/images/login.png';

import {Background} from 'components';
import LoginDisclaimer from 'containers/LoginPage/LoginDisclaimer';
import PasswordResetConfirmForm from './PasswordResetConfirmForm';
import EulaContent from './eula';

// Password reset link example (query separated)
// https://admin.acc.wisbits.nl/confirm-password
// ?id=08b4702c-0557-461d-bb70-2044cdc8a0a4
// &token=a1e9c517-6bd9-4872-a245-21486d11ddd8

const ResetPasswordConfirm: FC = () => {
  const [showEula, setShowEula] = useState(false);
  return (
    <>
      <Background>
        <div
          className={`py-12 px-4 ${
            showEula ? 'max-w-800' : 'max-w-640'
          } mx-auto flex flex-col justify-center`}
        >
          <img src={loginImage} className="mx-auto -mb-16" alt="Login" />
          {showEula ? (
            <EulaContent onDone={() => setShowEula(false)} />
          ) : (
            <PasswordResetConfirmForm onShowEula={() => setShowEula(true)} />
          )}
          <LoginDisclaimer />
        </div>
      </Background>
    </>
  );
};

export default ResetPasswordConfirm;
